import { render } from "./ClassOwnerEditView.vue?vue&type=template&id=0280febc&scoped=true"
import script from "./ClassOwnerEditView.vue?vue&type=script&lang=js"
export * from "./ClassOwnerEditView.vue?vue&type=script&lang=js"

import "./ClassOwnerEditView.vue?vue&type=style&index=0&id=0280febc&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0280febc"]])

export default __exports__